import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import LeagueCreateEditForm from './Components/LeagueCreateEditForm';
import LeagueApi from './LeagueApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: LeagueCreateEditForm,
                getCreate: LeagueApi.create,
                defaults: { keyFeatures: [] },
                successMessage: "League Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}